/**
 * Shared staleness marker for the Computer dashboard GraphQL preload cache.
 *
 * Surfaces that create Computer tasks outside the dashboard (home ask input,
 * taskbar, sidecar) cannot reach the dashboard Relay environment without
 * pulling Relay into their bundle. They mark the cache stale here instead;
 * the graphql-preload module consumes the flag on the next dashboard load and
 * performs the actual invalidation. This module must stay dependency-free.
 */
let computerDashboardGraphQLCacheStale = false;
export function markComputerDashboardGraphQLCacheStale() {
    computerDashboardGraphQLCacheStale = true;
}
export function consumeComputerDashboardGraphQLCacheStale() {
    const wasStale = computerDashboardGraphQLCacheStale;
    computerDashboardGraphQLCacheStale = false;
    return wasStale;
}
//# sourceMappingURL=computerDashboardGraphQLCacheState.js.map